import React from 'react'
import user from "../../../../assets/img/admin/user-add-green.svg"
import line from "../../../../assets/img/admin/eslips.svg";
import profile from "../../../../assets/img/Home/profile.png";
const NotificationCard = ({info}) => {
  return (
    <div className='NotificationCard'>
     <div className='flex  justify-between items-center mb-[40px]'>
     <div className='NotificationCard__title flex gap-[9px]'>
        <img src={user}/>
        <div >
          <p className='NotificationCard__title--date'>۶ دقیقه پیش</p>
          <p className='NotificationCard__title--sub'> {info.subject}</p>
        </div>

      </div>

      <button className=''>
      <img src={line}/>
      </button>
     </div>
     <div className='flex justify-between items-center'>
       <p className='NotificationCard__req'>{info.body}</p>
       <img  className='NotificationCard__profile' src={profile}/>
     </div>
    </div>
  )
}

export default NotificationCard